import React from 'react'

import { motion } from 'framer-motion'
import { CloseIcon } from '@chakra-ui/icons'
import {
  Button,
  chakra,
  Heading,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from '@chakra-ui/react'

import { useCompany, useUserCompanies } from '@/react-query/company'
import { useUpdateInterview } from '@/react-query/interview/interview'
import { useIsViewOnlyMember } from '@/react-query/team'
import { ArrowSvg } from '@/views/assets/ArrowSvg'
import { PlusIcon } from '@/views/assets/PlusIcon'
import Card from '@/views/components/Card/Card'
import { EditCompanyModal } from '@/views/screens/Interview/components/CompanyCard/EditCompanyModal'

export const CompanyCard: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const isViewOnlyUser = useIsViewOnlyMember()
  const userCompanies = useUserCompanies()
  const company = useCompany()
  const updateInterview = useUpdateInterview()

  return (
    <Card className="flex items-start flex-col px-[2.5rem] py-[1.8rem] mb-6">
      <>
        <Heading size={'sm'}>Company</Heading>
        {company.data ? (
          <MotionBox
            display={'flex'}
            flexDirection={'column'}
            as={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className="mt-5 flex flex-row items-center">
              <Text
                fontWeight={'bold'}
                fontSize={'1.25rem'}
                overflowWrap={'anywhere'}
              >
                {company.data?.name}
              </Text>
              {!isViewOnlyUser && (
                <IconButton
                  variant={'brand-solid-white'}
                  rounded={'full'}
                  ml={3}
                  aria-label={'Remove Company'}
                  icon={<CloseIcon />}
                  onClick={() => {
                    updateInterview.mutate({
                      companyId: null,
                    })
                  }}
                />
              )}
            </div>

            {!isViewOnlyUser && (
              <Button
                rounded={'1.25rem'}
                mt={5}
                onClick={onOpen}
                alignSelf={'flex-start'}
                variant={'brand-solid-white'}
              >
                Edit...
              </Button>
            )}
          </MotionBox>
        ) : (
          !isViewOnlyUser && (
            <div>
              <Menu>
                <MenuButton
                  variant={'brand-solid-white'}
                  as={Button}
                  rounded={'full'}
                  rightIcon={<ArrowSvg />}
                  mt={5}
                  isDisabled={userCompanies.data?.length === 0}
                >
                  Select from saved
                </MenuButton>

                <MenuList maxHeight={'20rem'} overflow={'auto'}>
                  {[...(userCompanies.data || [])]
                    .sort((a, b) => {
                      if (a.createdAt > b.createdAt) {
                        return -1
                      }
                      if (a.createdAt < b.createdAt) {
                        return 1
                      }

                      return 0
                    })
                    .map((company) => {
                      return (
                        <MenuItem
                          key={company.id}
                          onClick={() => {
                            updateInterview.mutate({
                              companyId: company.id,
                            })
                          }}
                        >
                          {company.name}
                        </MenuItem>
                      )
                    })}
                </MenuList>
              </Menu>

              <Button
                variant={'brand-solid-white'}
                rounded={'full'}
                mt={5}
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontWeight={'bold'}
                onClick={(event) => {
                  event.preventDefault()
                  onOpen()
                }}
              >
                <PlusIcon stroke={'black'} />
                &nbsp;&nbsp;&nbsp;Create new...
              </Button>
            </div>
          )
        )}
        <EditCompanyModal isOpen={isOpen} onClose={onClose} />
      </>
    </Card>
  )
}

const MotionBox = motion(chakra.div)
